<template>
  <BaseExportContact
    :postFixer="postFixer"
    :showSelectBuilding="false"
  />
</template>

<script>
import { computed } from 'vue-demi'
import { exportMarketing } from '@/api/ccdcontacts/request'
import BaseExportContact from '@/pages/ccd/BaseExportContact'
import { aclHelper, ccdPermsTypes } from '@/utils/aclHelper'

export default {
  name: 'ExportMarketingContact',
  components: {
    BaseExportContact,
  },
  setup () {
    const exportBtn = computed(() => {
      const hasAccess = aclHelper.getAccess(ccdPermsTypes.exportContact.exportMarketing)
      return hasAccess ? {
        actionTitle: 'export',
        func: exportMarketing,
      } : {}
    })
    return {
      exportBtn,
      postFixer: 'marketing',
    }
  },
}
</script>
